import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { employeeService } from "../services/lessonService";
import { createCustomAsyncThunk } from "./utils";

export const getEmployeeGroupSubjects = createCustomAsyncThunk(
    "employeeGroupSubjects/get",
    async params => await employeeService.getGroupSubjects(params)
)

const adapter = createEntityAdapter({
    selectId: x => `${x.group_id} ${x.subject_id}`
})

const employeeGroupSubjectsSlice = createSlice({
    name: "employeeGroupSubjects",
    initialState: adapter.getInitialState({
        isLoading: false,
        error: null,
        current: null,
    }),
    reducers: {
        setCurrentEmployeeGroupSubject: (state, action) => { state.current = action.payload },
        resetEmployeeGroupSubjects: state => {
            state.current = null
            adapter.removeAll(state)
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getEmployeeGroupSubjects.pending, state => { state.isLoading = true })
            .addCase(getEmployeeGroupSubjects.fulfilled, (state, action) => {
                adapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getEmployeeGroupSubjects.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

export default employeeGroupSubjectsSlice.reducer

export const { resetEmployeeGroupSubjects, setCurrentEmployeeGroupSubject } = employeeGroupSubjectsSlice.actions

export const employeeGroupSubjectsSelectors = adapter.getSelectors(x => x.employeeGroupSubjects)

export const useEmployeeGroupSubjects = employee => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (employee) { dispatch(getEmployeeGroupSubjects({ employee_id: employee })) }
        return () => dispatch(resetEmployeeGroupSubjects())
    }, [dispatch, employee])

    const groupSubjects = useSelector(employeeGroupSubjectsSelectors.selectAll)
    const groupSubjectsIsLoading = useSelector(x => x.employeeGroupSubjects.isLoading)
    const currentGroupSubject = useSelector(x => x.employeeGroupSubjects.current)

    const setCurrentGroupSubject = gs => dispatch(setCurrentEmployeeGroupSubject(gs))

    return { currentGroupSubject, setCurrentGroupSubject, groupSubjects, groupSubjectsIsLoading }
}